const KEY_PROTECTION = 'CART_PROTECTION_STATUS';
const statusProtection = {
  enable: 'enable_protection',
};

function setupCartProtectionMonitor(attempts = 0) {
  const maxAttempts = 10;
  const cart = document.querySelector('#upCart');
  const {enable} = statusProtection;

  if (!cart) {
    if (attempts < maxAttempts) {
      setTimeout(() => setupCartProtectionMonitor(attempts + 1), 1000);
    } else {
      console.warn('Cart not found after multiple attempts');
    }
    return;
  }

  function getStatusAddProtection() {
    return localStorage.getItem(KEY_PROTECTION);
  }

  function setStatusAddProtection(status) {
    return localStorage.setItem(KEY_PROTECTION, status);
  }

  function deleteStatusData() {
    return localStorage.removeItem(KEY_PROTECTION);
  }

  function activeProtectionProduct() {
    try {
      const toggleProtectionBtn = cart.querySelector('.upcart-addons-toggle [class^="styles_ToggleSwitch"]');

      if (!toggleProtectionBtn && getStatusAddProtection()) {
        deleteStatusData();
        return;
      }

      if (!toggleProtectionBtn || getStatusAddProtection() === enable) return;

      const isActiveProtection = toggleProtectionBtn.className.toLowerCase().includes('active');

      if (!isActiveProtection) {
        toggleProtectionBtn.click();
        setStatusAddProtection(enable);
      }
    } catch (err) {
      console.error('Failed to activate cart protection:', err);
    }
  }

  let timeout = null;
  const observerConfig = {
    childList: true,
    subtree: true
  };

  const observer = new MutationObserver(() => {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      activeProtectionProduct();
    }, 1000);
  });
  observer.observe(cart, observerConfig);
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(setupCartProtectionMonitor, 1000);
});